import { createCommand } from 'lexical';

export const SAVE_COMMAND = createCommand('SAVE_COMMAND');
